import React, {useCallback} from 'react';
import cn from 'classnames';

import Skeleton from 'coreComponents/Skeleton';
import {useApplePay} from 'coreHooks';
import {EAddToCartType} from 'coreStore/data/ui/types';

import Button from 'brandComponents/Button';

import {IApplePayButtonProps} from './IApplePayButton';

import styles from './ApplePayButton.module.scss';

const ApplePayButton = ({classNames, onClick, isProduct}: IApplePayButtonProps) => {
	const applePayHandler = useApplePay();
	let result = null;

	const handleClick = useCallback(() => {
		if (isProduct) {
			onClick(EAddToCartType.APPLEPAY);
		} else {
			applePayHandler.handle();
		}
	}, [onClick, isProduct, applePayHandler]);

	if (applePayHandler.loaded) {
		result = <Button onClick={handleClick} classNames={cn('apple-pay-button', styles['apple-pay-button'], classNames)}></Button>;
	} else if (applePayHandler.loading) {
		result = <Skeleton height="20px" width="100px" />;
	}

	return result;
};

export default ApplePayButton;
